import React from 'react';
import classNames from 'classnames';

import throttler from 'rebook/apps/utils/throttler';

import styles from './style.scss';


class ProcessLowQualityImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      naturalWidth: null,
      lowQualityRatio: 1.5,
      isBlurred: true, // use preblurr
    };
  }

  componentDidMount() {
    const handler = () => this.processImage(this.image.clientWidth, this.state.naturalWidth);
    window.addEventListener('resize', () => throttler(handler, 100), false);
  }

  // process if image is larger then original more then lowQualityRatio times
  processImage(clientWidth, naturalWidth) {
    const isBlurred = clientWidth > naturalWidth * this.state.lowQualityRatio;
    this.setState({ isBlurred });
  }

  handleOnSourceLoad(sourceImage, clientWidth) {
    const { naturalWidth } = sourceImage;
    this.setState({ naturalWidth });
    this.processImage(clientWidth, naturalWidth);
  }

  handleOnLoad() {
    const sourceImage = new Image();
    const { clientWidth } = this.image;

    sourceImage.src = this.image.src;
    sourceImage.addEventListener('load', () => this.handleOnSourceLoad(sourceImage, clientWidth));
  }

  render() {
    const { isBlurred } = this.state;

    return React.createElement('img', {
      ...this.props,
      className: classNames(this.props.className, styles.image, { isBlurred }),
      ref: (image) => { this.image = image; },
      onLoad: () => this.handleOnLoad(),
    });
  }
};

export default ProcessLowQualityImage;
